const CardHeader = ({ title, description }) => {
  return (
    <div className="flex flex-col gap-3 ">
      <p className="text-grey-02 self-stretch text-[22px] leading-[28px] font-semibold md:text-[36px] md:leading-[44px] font-google md:text-center">
        {title}
      </p>
      <p className="text-grey-04 text-[12px] leading-[18px] font-normal md:text-[16px] md:leading-[24px] font-inter md:text-center">
        {description}
      </p>
    </div>
  );
};
export default CardHeader;
